module.exports = __webpack_public_path__ + "img/gold4.b02374f6.png";